var map = {
	"./2010/People/Index.vue": 36075,
	"./2010/Program/Index.vue": 61911,
	"./2011/People/Index.vue": 62159,
	"./2011/Program/Index.vue": 72007,
	"./2012/People/Index.vue": 49839,
	"./2012/Program/Index.vue": 56641,
	"./2013/People/Index.vue": 54668,
	"./2013/Program/Index.vue": 63686,
	"./2014/People/Index.vue": 44865,
	"./2014/Program/Index.vue": 53384,
	"./2015/People/Index.vue": 90072,
	"./2015/Program/Index.vue": 50416,
	"./2016/People/Index.vue": 17541,
	"./2016/Program/Index.vue": 12937,
	"./2017/People/Index.vue": 24921,
	"./2017/Program/Index.vue": 71373,
	"./2018/People/Index.vue": 12553,
	"./2018/Program/Index.vue": 22227,
	"./2019/Index.vue": 30816,
	"./2019/People/Index.vue": 81915,
	"./2019/Program/Index.vue": 12227,
	"./2020/Index.vue": 75452,
	"./2020/People/Index.vue": 14903,
	"./2020/Program/Index.vue": 22253,
	"./2020/Sponsors/Index.vue": 98739,
	"./2021/Contact/Index.vue": 57203,
	"./2021/Index.vue": 44559,
	"./2021/People/Index.vue": 13675,
	"./2021/Platform/Index.vue": 92152,
	"./2021/Posters/Index.vue": 23708,
	"./2021/Program/Index.vue": 91133,
	"./2021/Registration/Index.vue": 60964,
	"./2021/Sponsors/Index.vue": 68970,
	"./2022/Contact/Index.vue": 33477,
	"./2022/Index.vue": 25521,
	"./2022/Masterclass/Index.vue": 29740,
	"./2022/People/Index.vue": 10309,
	"./2022/Platform/Index.vue": 50953,
	"./2022/Posters/Index.vue": 70240,
	"./2022/Program/Index.vue": 74591,
	"./2022/Registration/Index.vue": 13037,
	"./2022/Sponsors/Index.vue": 32789,
	"./2022/Workshop/Index.vue": 50521,
	"./2023/Contact/Index.vue": 37172,
	"./2023/Index.vue": 6141,
	"./2023/Masterclass/Index.vue": 53392,
	"./2023/People/Index.vue": 98283,
	"./2023/Posters/Index.vue": 77242,
	"./2023/Program/Index.vue": 32223,
	"./2023/Registration/Index.vue": 32825,
	"./2023/Showcase/Index.vue": 53335,
	"./2023/Sponsors/Index.vue": 3886,
	"./2023/VR/Index.vue": 77998,
	"./2023/Venue/Index.vue": 37868,
	"./2024/Contact/Index.vue": 78895,
	"./2024/Index.vue": 44672,
	"./2024/Masterclass/Index.vue": 53117,
	"./2024/People/Index.vue": 81277,
	"./2024/Posters/Index.vue": 52513,
	"./2024/Program/Index.vue": 67312,
	"./2024/Registration/Form/Index.vue": 32611,
	"./2024/Registration/Index.vue": 35852,
	"./2024/Showcase/Index.vue": 31431,
	"./2024/Sponsors/Index.vue": 3929,
	"./2024/Venue/Index.vue": 35071,
	"./2025/Contact/Index.vue": 54546,
	"./2025/Index.vue": 33757,
	"./2025/Masterclass/Index.vue": 17937,
	"./2025/People/Index.vue": 13528,
	"./2025/Posters/Index.vue": 71210,
	"./2025/Program/Index.vue": 31096,
	"./2025/Registration/Form/Index.vue": 86846,
	"./2025/Registration/Index.vue": 29040,
	"./2025/Showcase/Index.vue": 91529,
	"./2025/Sponsors/Index.vue": 19261,
	"./2025/Venue/Index.vue": 78652
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45112;